import React, {Component} from 'react';
import Select from 'react-select';
import {connect} from 'react-redux';
import Modal from '../../components/Modal';
import {updateClientStage} from '../../actions/ClientActions';
import clientStages from '../../constants/clientStages';

@connect(
    state => ({
        isSavingClientStage: state.modal.isSavingClientStage
    }),
    { updateClientStage }
)
export default class ClientStageModal extends Component {

	constructor(props){
		super(props);
		this.state = {
			clientStageId: props.client.clientStageId
		}
	}

    updateClientStage() {
        this.props.dispatch(updateClientStage(
        	this.props.client.id,
        	this.state.clientStageId
        ));
    }
    handleClientStageChange(value){
        this.setState({
            clientStageId : value
        });
    }

    render() {        
        var actionButton = this.props.isSavingQualify ?
            (<button className="btn btn-success disabled">Saving...</button>) :
            (<button className="btn btn-success" onClick={this.updateClientStage.bind(this)}>Save Stage</button>);

        var options = clientStages.map(stage => {
            return { value: stage.id, label: stage.name };
        });

        return (
            <Modal actionButton={actionButton} className="modal modal-success" title={"Change Client Stage"}>
                <Select
                    placeholder="Select Stage"
                    multi={false}
                    name="clientStage"
                    value={this.state.clientStageId}
                    options={options}
                    onChange={this.handleClientStageChange.bind(this)} />

                <br/><br/><br/> {/* wat */}
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ClientStageModal.js